import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {combineLatest, Subject} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {Header, Subheader, Logo} from '../../static';
import {RegisterFooter} from '../footer';
import {Input, Checkbox, Toggle} from '../../inputs';
import {Wrapper as ButtonsWrapper} from '../../buttons/wrapper';
import {Button} from '../../buttons/button';
import {FormError} from 'app/model/FormError';
import {Translate} from 'app/services/translate';
import {validateEmail, validateNullability} from '../../validator';
import {AuthService} from 'app/components/sign/auth.service';
import {SocialLogin} from '../../social/social';
import {Error} from "../../static/error";
import {find} from 'lodash';

export class IndividualCustomerRegistrationForm extends Component {
    static get propTypes() {
        return {
            socialRegisterAvailable: PropTypes.bool.isRequired,
            forwardReferer: PropTypes.bool,
        };
    }

    constructor(props) {
        super(props);

        this.auth = new AuthService();

        this.state = {
            email: null,
            password: null,
            newsletter: false,
            errors: [],
        };

        this.email$ = new Subject();
        this.pass$ = new Subject();
        this.newsletter$ = new Subject();

        this.errors$ = (new Subject()).pipe(map((errors) => errors.map(FormError.mapToThis)));
        this.emailErrors$ = this.errors$.pipe(map((errors) => errors.filter((error) => error.isType('email'))));
        this.socialErrors$ = this.errors$.pipe(map((errors) => errors.filter((error) => error.isType('social'))));
        this.passwordErrors$ = this.errors$.pipe(map((errors) => errors.filter((error) => error.isType('password'))));

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        combineLatest([
            this.email$.pipe(startWith(null)),
            this.pass$.pipe(startWith(null)),
            this.newsletter$.pipe(startWith(false)),
        ])
            .pipe(
                map(([email, password, newsletter]) => ({email, password, newsletter}))
            )
            .subscribe(this.setState.bind(this));

        this.email$.subscribe((email) => this.emailErrors$.next(validateEmail(email)));
        this.pass$.subscribe((password) => this.passwordErrors$.next(validateNullability(password)));
        this.errors$.subscribe((errors) => this.setState({errors}));
    }

    handleSubmit(evt) {
        evt.preventDefault();

        const {email, password, newsletter} = this.state;
        const options = {
            forwarded_referer: (this.props.forwardReferer && window.document.referrer) ? window.document.referrer : null
        };

        this.auth.signUp({email, password, newsletter}, options)
            .then(() => this.errors$.next([]))
            .catch((err) => {
                const errors = err.response.data.errors;
                const userExists = find(errors, {code: 'email_already_taken'});

                if (userExists) {
                    return this.auth.signIn({username: email, password})
                        .then(() => this.setState({errors: []}))
                        .catch(() => this.errors$.next(errors))
                }

                this.errors$.next(errors)
            });
    }

    render() {
        return (
            <div className="form-container">
                <form onSubmit={this.handleSubmit} role="form">
                    <Logo/>
                    <Header>{Translate('signing_register_header')}</Header>
                    <Subheader>{Translate('signing_register_subheader')}</Subheader>

                    {find(this.state.errors, {type: 'global'}) && (
                        <div className="mt-3 text-center">
                            <Error errors={this.state.errors}/>
                        </div>
                    )}

                    <Input label="E-mail" type="email" errors$={this.emailErrors$} handleChange$={this.email$}/>
                    <Input
                        label={Translate('signing_register_password')}
                        type="password"
                        errors$={this.passwordErrors$}
                        handleChange$={this.pass$}/>
                    <Checkbox handleChange$={this.newsletter$}/>
                    {false && <Toggle handleChange$={this.referral$}>{Translate('signing_register_referrals')}</Toggle>}

                    <ButtonsWrapper>
                        <Button type="submit">{Translate('signing_register_register_button')}</Button>
                    </ButtonsWrapper>

                    {this.props.socialRegisterAvailable && (
                        <SocialLogin
                            formType="register"
                            errors$={this.errors$}
                            dividerText={Translate('signing_register_divider')}
                            forwardReferer={this.props.forwardReferer}
                            registration
                            newsletter={this.state.newsletter}/>
                    )}

                    <RegisterFooter/>
                </form>
            </div>
        );
    }
}
